(function () {
  if (window.__aelizaCameraStability) return;
  window.__aelizaCameraStability = true;

  function init() {
    var root = document.querySelector('[data-self-reflection]');
    if (!root) return;

    var video = root.querySelector('[data-sr-video]');
    var startButton = root.querySelector('[data-sr-start]');
    var stopButton = root.querySelector('[data-sr-stop]');
    var liveControls = root.querySelector('[data-sr-live-controls]');
    var captureControls = root.querySelector('[data-sr-capture-controls]');
    if (!video || !startButton || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return;

    var desired = false;
    var recovering = false;
    var disposed = false;
    var retryTimer = null;
    var retryCount = 0;
    var lastTime = -1;
    var lastAdvanceAt = Date.now();
    var watchdog = null;

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
    }

    function constraints() {
      return isMobile()
        ? { video: { facingMode: { ideal: 'user' }, width: { ideal: 1080 }, height: { ideal: 1920 }, aspectRatio: { ideal: 0.5625 } }, audio: false }
        : { video: { facingMode: { ideal: 'user' }, width: { ideal: 1920 }, height: { ideal: 1080 }, aspectRatio: { ideal: 1.7777777778 } }, audio: false };
    }

    function liveViewIsActive() {
      return desired && !disposed && !document.hidden && !video.hidden &&
        (!liveControls || !liveControls.hidden) &&
        (!captureControls || captureControls.hidden);
    }

    function currentTrack() {
      var stream = video.srcObject;
      return stream && stream.getVideoTracks ? stream.getVideoTracks()[0] : null;
    }

    function resetProgressClock() {
      lastTime = Number(video.currentTime) || 0;
      lastAdvanceAt = Date.now();
    }

    function clearRetry() {
      if (retryTimer) clearTimeout(retryTimer);
      retryTimer = null;
    }

    function stopStream(stream) {
      if (!stream || !stream.getTracks) return;
      stream.getTracks().forEach(function (track) {
        try { track.stop(); } catch (error) {}
      });
    }

    function bindTrack(track) {
      if (!track) return;
      track.addEventListener('ended', function () {
        if (liveViewIsActive()) scheduleRecovery(250);
      }, { once: true });
    }

    function scheduleRecovery(delay) {
      if (!liveViewIsActive() || recovering || retryTimer) return;
      retryTimer = setTimeout(function () {
        retryTimer = null;
        recoverCamera();
      }, typeof delay === 'number' ? delay : 400);
    }

    async function recoverCamera() {
      if (!liveViewIsActive() || recovering) return;
      recovering = true;
      root.dataset.cameraStatus = 'recovering';

      var oldStream = video.srcObject;
      try {
        try { await video.play(); } catch (playError) {}
        await new Promise(function (resolve) { setTimeout(resolve, 300); });

        var track = currentTrack();
        if (track && track.readyState === 'live' && !video.paused && video.readyState >= 2) {
          recovering = false;
          root.dataset.cameraStatus = 'live';
          resetProgressClock();
          return;
        }

        stopStream(oldStream);
        if (video.srcObject === oldStream) video.srcObject = null;

        var newStream = await navigator.mediaDevices.getUserMedia(constraints());
        if (!desired || disposed) {
          stopStream(newStream);
          recovering = false;
          return;
        }

        video.srcObject = newStream;
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        bindTrack(newStream.getVideoTracks && newStream.getVideoTracks()[0]);
        await video.play();

        retryCount = 0;
        root.dataset.cameraStatus = 'live';
        resetProgressClock();
        root.dispatchEvent(new CustomEvent('sr:camera-recovered'));
      } catch (error) {
        console.warn('Reflection Index camera recovery:', error);
        root.dataset.cameraStatus = 'interrupted';
        retryCount += 1;
        var name = error && error.name;
        if (name !== 'NotAllowedError' && name !== 'SecurityError' && desired && !disposed) {
          setTimeout(function () {
            recovering = false;
            scheduleRecovery(Math.min(15000, 1000 * Math.pow(2, Math.min(retryCount, 4))));
          }, 0);
          return;
        }
      }
      recovering = false;
    }

    function inspectCamera() {
      if (!liveViewIsActive()) {
        resetProgressClock();
        return;
      }

      var track = currentTrack();
      if (!track || track.readyState !== 'live') {
        scheduleRecovery(200);
        return;
      }

      var now = Date.now();
      var time = Number(video.currentTime) || 0;
      if (time > lastTime + 0.03) {
        lastTime = time;
        lastAdvanceAt = now;
        root.dataset.cameraStatus = 'live';
        return;
      }

      if (video.paused) {
        video.play().catch(function () { scheduleRecovery(300); });
      }
      if (now - lastAdvanceAt > 4500) scheduleRecovery(200);
    }

    startButton.addEventListener('click', function () {
      desired = true;
      disposed = false;
      retryCount = 0;
      clearRetry();
      setTimeout(function () {
        var track = currentTrack();
        if (track) bindTrack(track);
        resetProgressClock();
      }, 800);
    }, true);

    video.addEventListener('playing', function () {
      if (video.srcObject) {
        desired = true;
        bindTrack(currentTrack());
        root.dataset.cameraStatus = 'live';
        resetProgressClock();
      }
    });

    video.addEventListener('emptied', function () {
      if (!video.srcObject) {
        root.dataset.cameraStatus = 'off';
        resetProgressClock();
      }
    });

    if (stopButton) stopButton.addEventListener('click', function () {
      desired = false;
      clearRetry();
    }, true);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        resetProgressClock();
      } else if (desired) {
        setTimeout(function () {
          var track = currentTrack();
          if (!track || track.readyState !== 'live' || video.paused) scheduleRecovery(100);
          else resetProgressClock();
        }, 350);
      }
    });

    window.addEventListener('pageshow', function () {
      if (desired) setTimeout(inspectCamera, 350);
    });

    window.addEventListener('pagehide', function () {
      disposed = true;
      desired = false;
      clearRetry();
      stopStream(video.srcObject);
    });

    watchdog = setInterval(inspectCamera, 1500);
    root.dataset.cameraStability = 'enabled';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();